import { DEEP_LINK_COMMAND_QUERY_KEY } from 'src/components/DeepLinkCommand/constants';
import { DeepLinkCommandName } from 'src/components/DeepLinkCommand/types';

export const getCommandFromQueryParams = (params: URLSearchParams): DeepLinkCommandName | null =>
    params.get(DEEP_LINK_COMMAND_QUERY_KEY) as DeepLinkCommandName | null;
